import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_LOADED,
  AUTH_ERROR,
} from "../actions/types";

const initialState = {
  token: null,
  isAuthenticated: false,
  loading: true,
  user: {
    isAdmin: false,
    name: "",
  },
  purchases: [],
  stripeCustomerId: "",
};

if (typeof localStorage != "undefined") {
  initialState.token = localStorage.getItem("token");
}

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload[0],
        purchases: payload[1],
        stripeCustomerId: payload[2],
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };
    case LOGIN_FAIL:
    case AUTH_ERROR:
    case LOGOUT:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: {},
        purchases: [],
      };
    default:
      return state;
  }
}
